import { cn } from '@/shared/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

/** Figma 배지 규격: 11px · Medium · px 8 / py 3 · radius 5 */
const badgeVariants = cva(
  'inline-flex shrink-0 items-center rounded-badge px-2 py-[3px] text-[11px] leading-[17px] font-medium whitespace-nowrap',
  {
    variants: {
      tone: {
        neutral: 'bg-muted text-ink-4', // 그룹 개수
        muted: 'bg-muted text-ink-6', // 거래 종료 · 종료·거절
        app: 'bg-muted text-ink-7', // [앱] 배지 (회색 배경 위면 onWhite 사용)
        onWhite: 'bg-surface text-ink-7', // 비활성 버튼 안의 [앱] 배지
        primary: 'bg-primary-soft text-primary', // 의원급
        success: 'bg-success-soft text-success', // 거래 중 · 병원급
        warning: 'bg-warning-soft text-warning', // 확인 중 · 필터링 신청
        danger: 'bg-danger-soft text-danger', // 신청 거절
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
);

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = ({ className, tone, ...props }: BadgeProps) => (
  <span className={cn(badgeVariants({ tone }), className)} {...props} />
);

// eslint-disable-next-line react-refresh/only-export-components
export { Badge, badgeVariants };
